<template>
    <v-container v-resize="onResize">
         <v-layout v-if="!loading" row wrap >
            <v-flex sm12 md6 lg8>
                <statistical-header containedInCol="true" :title="title"></statistical-header>
                <br />
            </v-flex>
            <v-flex sm6 md3 lg2 class="pt-5 pt-xs-0 pb-xs-3">
                <count-up :endVal="totalIndigenousCount" :text="totalIndigenousCountText" />
            </v-flex>
            <v-flex sm6 md3 lg2 class="pt-5 pt-xs-0 pb-xs-3">
                <count-up :endVal="indigenousAustraliansInCurrentParliament" :text="indigenousAustraliansInCurrentParliamentText" />
            </v-flex>
        </v-layout>
        <loader v-if="loading" />
        <template v-if="!loading">
            <statistical-member-or-senator-selector  :value="selectedMpOrSenator" @input="selectedMpOrSenator = $event" />
            <v-layout row wrap align-left>
                <v-flex xs12 md12 lg5 xl4  order-sm1 order-xs4>
                    <v-layout row wrap align-center justify-space-between>
                        <v-btn-toggle v-model="chartType" class="transparent handbook_toggleButton mt-4" :mandatory="true">
                            <v-tooltip top :disabled="this.$vuetify.breakpoint.name !== 'md'">
                                <template v-slot:activator="{ on }">
                                    <v-btn v-on="on" class="handbook_button" :value="'timeline'">
                                        <span class="long-button-text chamberButton">Timeline</span>
                                    </v-btn>
                                </template>
                                <span>Timeline</span>
                            </v-tooltip>
                            <v-tooltip top :disabled="this.$vuetify.breakpoint.name !== 'md'">
                                <template v-slot:activator="{ on }">
                                    <v-btn v-on="on" class="handbook_button" :value="'byParty'">
                                        <span class="long-button-text chamberButton">By Party</span>
                                    </v-btn>
                                </template>
                                <span>By Party</span>
                            </v-tooltip>
                            <v-tooltip top :disabled="this.$vuetify.breakpoint.name !== 'md'">
                                <template v-slot:activator="{ on }">
                                    <v-btn v-on="on" class="handbook_button" :value="'byState'">
                                        <span class="long-button-text chamberButton">By State</span>
                                    </v-btn>
                                </template>
                                <span>By State</span>
                            </v-tooltip>
                            <v-tooltip top :disabled="this.$vuetify.breakpoint.name !== 'md'">
                                <template v-slot:activator="{ on }">
                                    <v-btn v-on="on" class="handbook_button" :value="'byParliament'">
                                        <span class="long-button-text chamberButton">By Parliament/Chamber</span>
                                    </v-btn>
                                </template>
                                <span>By Parliament/Chamber</span>
                            </v-tooltip>
                        </v-btn-toggle>
                    </v-layout>
                </v-flex>
                <v-flex xs12 md4 lg3 xl3  order-sm2 order-xs1>
                    <v-layout class="mr-5 pt-2" row wrap align-center justify-space-between>
                        <v-text-field
                            v-model="search"
                            @keydown.enter="isOpen = false"
                            @keydown.esc="isOpen = false"
                            @input="debouncedOnChange"
                            append-icon="search"
                            label="Search"
                            single-line
                            hide-details></v-text-field>
                    </v-layout>
                </v-flex>
                <v-flex xs12 md4 lg2 xl3  order-sm3 order-xs2>
                    <v-autocomplete class="mr-5 pt-4" :items="PARTIES"
                  
                        :label="partySelectLabel"
                        v-model="SELECTED_PARTIES"
                        v-on:change="PERFORM_SEARCH"
                        :search-input.sync="partySearchInput"
                        auto-select-first multiple small-chips deletable-chips>
                        <template v-slot:selection="{ item, index }">
                            <v-chip @input="deletePartySelectionItem(item)" small close v-if="index == 0">{{item}}</v-chip>
                            <v-chip small v-if="index == 1">+ {{SELECTED_PARTIES.length - 1}} more</v-chip>
                        </template>
                    </v-autocomplete>
                </v-flex>
                <v-flex xs12 md4 lg2 xl2  order-sm4 order-xs3>
                    <v-autocomplete class="pt-4" :items="this.$store.getters.GET_STATES.filter(s => this.StatesToExclude.filter(e => e.name == s.Name).length == 0)"
                        item-text="Name" item-value="Abbrev"
                        :label="stateSelectLabel"
                        v-model="SELECTED_STATES"
                        v-on:change="PERFORM_SEARCH"
                        :filter="FILTER_STATE_OPTIONS"
                        :search-input.sync="stateSearchInput"
                        multiple small-chips deletable-chips>
                        <template v-slot:selection="{ item, index }">
                            <v-chip @input="deleteStateSelectionItem(item.Abbrev)" small close v-if="index == 0">{{item.Name}}</v-chip>
                            <v-chip small v-if="index == 1">+ {{SELECTED_STATES.length - 1}} more</v-chip>
                        </template>
                    </v-autocomplete>
                </v-flex>
            </v-layout>

            <chart id="timeline" v-show="chartType === 'timeline'" :chartData="timelineData" />
            <div v-show="chartType === 'byParty'" style="background:white" class="pb-1">
                <chart id="byParty"  :chartData="byPartyData" />
                <p class="pl-3">Please note: A Parliamentarian may be counted in the chart under multiple parties if they changed parties during their term.</p>
            </div>
            <chart id="byState" v-show="chartType === 'byState'" :chartData="byStateData" />
            <chart id="byParliament" v-show="chartType === 'byParliament'" :chartData="byParliamentData" />

            <br/>
            <v-menu v-if="this.isMobile" d-inline offset-y :nudge-left="140" :close-on-content-click="true">
                <v-btn outline small slot="activator">
                    Sort <v-icon>sort</v-icon>
                </v-btn>
                <v-list>
                        <v-subheader
                        >
                        Sort by:
                        </v-subheader>
                    <v-list-tile v-for="(item, index) in headers.filter(h => h.text != '' && h.sortable != false)" :key="item.value" @click="changeSort(item.value)">
                        <v-list-tile-title>
                            {{ item.text }}
                            <v-icon v-if="PAGINATION.sortBy === item.value">{{PAGINATION.descending ? 'arrow_downward':'arrow_upward'}}</v-icon>
                        </v-list-tile-title>
                    </v-list-tile>
                </v-list>
            </v-menu>
            <v-data-table
                :headers="headers" 
                :items="filteredItems"
                :rows-per-page-items="rowsPerPageItems"
                :loading="loading"
                :custom-sort="customSort"
                :pagination.sync="PAGINATION" 
                :hide-headers="isMobile"
                :class="{ mobileDataTable: isMobile, 'elevation-1': true }"
                :disable-initial-sort="true">
                <template v-slot:items="props">
                    <template v-if="isMobile">
                        <tr>
                            <td>
                                <div class="flex-content">
                                    <div class="flex-item">
                                        <h3><router-link :to="{ name: $store.state.ROUTE_PARLIAMENTARIAN, params: { PHID: props.item.Phid }}">{{ props.item.DisplayName }}</router-link></h3>
                                    </div>
                                    <div class="flex-item flex-item-col flex-item-col-30">
                                        <div class="flex-item">
                                            <Portrait v-bind:PHID="props.item.Phid" :fixedWidth="80"></Portrait>
                                        </div>
                                    </div>
                                    <div class="flex-item flex-item-col flex-item-col-70">
                                        <div class="flex-item" data-label="Party">
                                            <div v-for="party in props.item.PartyService" :key="party.$key" ><a @click="handlePartyClick(party.Id)">{{ party.Name }}</a></div>
                                        </div>
                                        <div class="flex-item" data-label="State">
                                            <div v-if="selectedMpOrSenator[0] === 'mp' && selectedMpOrSenator.length === 1"><div v-for="electorate in props.item.Electorate.filter((value, index, self) => index === self.findIndex(v => v.Id === value.Id))" :key="electorate.Id" >{{ electorate.Name }}</div></div>
                                            <div v-else><div v-for="state in props.item.State.filter((value, index, self) => index === self.findIndex(v => v.Id === value.Id))" :key="state.$key" ><a @click="handleStateClick(state.Id)">{{ state.Name }}</a></div></div>
                                        </div>
                                    </div>
                                    <div class="flex-item" data-label="Period of service">
                                        <div v-for="service in props.item.Service" :key="service.$key">
                                            {{ service.Text }}
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </template>
                    <template v-if="!isMobile">
                        <td class="text-xs-left">
                            <Portrait v-if="!hidePhotos" :PHID="props.item.Phid" :fixedWidth="80"></Portrait>
                        </td>
                        <td class="text-xs-left">
                            <router-link :to="{ name: $store.state.ROUTE_PARLIAMENTARIAN, params: { PHID: props.item.Phid }}">{{ props.item.DisplayName }}</router-link>
                        </td>
                        <td class="text-xs-left">
                            <span v-for="party in props.item.PartyService" :key="party.$key" >
                                <a @click="handlePartyClick(party.Id)">{{ party.Name }} {{party.Text }}</a>
                                <br />
                            </span>
                        </td>
                        <td class="text-xs-left" v-if="selectedMpOrSenator[0] === 'mp' && selectedMpOrSenator.length === 1">
                            <div v-for="electorate in props.item.Electorate.filter((value, index, self) => index === self.findIndex(v => v.Id === value.Id))" :key="electorate.Id" >
                                {{ electorate.Name }}
                            </div>
                        </td>
                        <td class="text-xs-left" v-else>
                            <div v-for="state in props.item.State.filter((value, index, self) => index === self.findIndex(v => v.Id === value.Id))" :key="state.$key" >
                                <a @click="handleStateClick(state.Id)">{{ state.Name.toUpperCase() }}</a>
                            </div>
                        </td>
                        <td class="text-xs-left">
                            <div v-for="service in props.item.Service" :key="service.$key">
                                {{ service.Text }}
                            </div>
                        </td>
                    </template>
                </template>
            </v-data-table>
            <br/>
            <v-layout row wrap>
                <v-flex xs12>
                    <v-btn class="csvButton" @click="exportCsv" v-on:keyup.enter="exportCsv" color="primary">
                        <v-icon aria-hidden="true" :class="csvDownloadClass">{{csvDownloadIcon}}</v-icon>
                        <span>&nbsp;Download as CSV</span>
                    </v-btn>
                </v-flex>
            </v-layout>   
            <v-dialog dark v-model="dialog" width="60%">
                <v-card>
                    <v-card-title class="headline  text-xs-center">Acknowledgement of Country</v-card-title>
                    <v-card-text>
                        We acknowledge the traditional owners and custodians of country throughout Australia and acknowledge their continuing connection to land, waters and community. We pay our respects to the people, the cultures and the elders past, present and emerging.
                    </v-card-text>
                    <v-card-text>
                        Aboriginal and Torres Strait Islander people are advised that this website contains names and images of deceased people.
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>

                        <v-btn color="green lighten-1"
                            flat
                            v-on:click="addCulturalSensitivityCookie">
                            Close
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>         
        </template>
    </v-container>
</template>
<script>
import Loader from '@/components/Loader.vue';
import StatisticalHeader from './StatisticalHeader.vue';
import StatisticalMemberOrSenatorSelector from './StatisticalMemberOrSenatorSelector.vue';
import Chart from './Chart.vue';
import Portrait from '@/components/Portrait.vue'
import axios from 'axios';
import _ from 'lodash';
window.Handbook = window.Handbook || {}
const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
axios.defaults.baseURL = apiUri;
import CountUp from './CountUp.vue';
import _debounce from 'lodash.debounce';
import orderBy from 'lodash.orderby';
import moment from 'moment'

export default {
    created() {
        this.initialiseItems();
    },
    components: {
        Loader,
        StatisticalHeader,
        StatisticalMemberOrSenatorSelector,
        Portrait,
        Chart,
        CountUp
    },
    methods: {
        initialiseItems() {
            this.loading = true;
            const parliamentarianType = this.selectedMpOrSenator.length == 0 || this.selectedMpOrSenator.length == 2 ?
                '' : this.selectedMpOrSenator[0];
            const url = `StatisticalInformation/IndigenousAustralians?parliamentariantype=${parliamentarianType}`;
            axios.get(`api/${url}`)
                .then(response => {
                    this.items = response.data;
                    this.filteredItems = response.data.slice();
                    this.totalIndigenousCount = response.data.length;
                    this.indigenousAustraliansInCurrentParliament = response.data.filter(p => p.InCurrentParliament).length;
                    const allParties = response.data.slice().reduce((r, obj) => r.concat(obj.PartyService.map(p => p.Name)), []);
                    const distinctParties = allParties.filter((v, i, a) => a.indexOf(v) === i).sort();
                    this.PARTIES = distinctParties;
                    this.SELECTED_PARTIES = this.SELECTED_PARTIES.filter(i => this.PARTIES.indexOf(i) > -1);

                    const statesWithNumbers = this.$store.getters.GET_STATES
                    .map((p, index) => ({
                        name: p.Name,
                        y: this.items.flatMap(i => this._.uniqBy(i.State, 'Name')).length > 0 ? 
                        this.items.flatMap(i => this._.uniqBy(i.State, 'Name')).filter(i => i.Name.toLowerCase() === p.Abbrev.toLowerCase()).length 
                        : 0
                    }));

                    this.StatesToExclude = statesWithNumbers.filter(s => s.y == 0);

                    this.loading = false;
                    this.PERFORM_SEARCH();
                });

            
        },
        filterMpOrSenator() {
            this.initialiseItems();
        },
        handlePartyClick(partyId) {
            const query = {
                "logicalOperator": "all",
                "children": [
                    {
                    "type": "query-builder-group",
                    "query": {
                        "logicalOperator": "all",
                        "children": [
                            {
                                "type": "query-builder-rule",
                                "query": {
                                "rule": "firstnations",
                                "selectedOperator": "is",
                                "selectedOperand": "Aboriginal and/or Torres Strait Islander",
                                "value": "Yes"
                                }
                            }
                        ]
                    }
                }]
            }
            if (partyId) {
                var partyVal = "[{\"field\":\"RefList1\",\"value\":[],\"simpleValue\":[],\"textValue\":\"" + partyId + "\",\"dateValue\":null,\"fieldType\":null}]";
                query.children[0].query.children.push({"type":"query-builder-rule","query":{"rule":"parties.represented.new","selectedOperator":"of","selectedOperand":"Parties represented", "value":partyVal }});
            }
            this.handleParliamentarianType(query);
            localStorage.query = JSON.stringify(query);    
            this.$router.push('/AdvancedSearch');
        },
        handleStateClick(stateId) {
            const query = {
                "logicalOperator": "all",
                "children": [
                    {
                    "type": "query-builder-group",
                    "query": {
                        "logicalOperator": "all",
                        "children": [
                            {
                                "type": "query-builder-rule",
                                "query": {
                                "rule": "firstnations",
                                "selectedOperator": "is",
                                "selectedOperand": "Aboriginal and/or Torres Strait Islander",
                                "value": "Yes"
                                }
                            }
                        ]
                    }
                }]
            }
            if (stateId) {
                query.children[0].query.children.push({"type":"query-builder-rule","query":{"rule":"state","selectedOperator":"of","selectedOperand":"State","value":stateId}});
            }
            this.handleParliamentarianType(query);
            localStorage.query = JSON.stringify(query);    
            this.$router.push('/AdvancedSearch');
        },
        handleParliamentarianType(query) {
            if (this.selectedMpOrSenator.length == 1) {
                const selected = this.selectedMpOrSenator[0];
                switch (selected) {
                    case 'senator':
                        query.children[0].query.children.push({"type":"query-builder-rule","query":{"rule":"mpOrSenator","selectedOperand":"Member or Senator","value":"senator"}});
                        break;
                    case 'mp':
                        query.children[0].query.children.push({"type":"query-builder-rule","query":{"rule":"mpOrSenator","selectedOperand":"Member or Senator","value":"member"}});
                }
            }
        },
        deleteStateSelectionItem(item) {
            this.SELECTED_STATES = this.SELECTED_STATES.filter(find => find !== item);
            this.PERFORM_SEARCH();
        },
        deletePartySelectionItem(item) {
            this.SELECTED_PARTIES = this.SELECTED_PARTIES.filter(find => find !== item);
               this.PERFORM_SEARCH();
        },
        customSort(items, index, isDesc) {
            
            items.sort((a, b) => {
                if (index === "Service") {
                    // for items, get party
                    // a is less than b is -1
                    // a is greater than b is 1
                    const aService = a[index][0].Date;
                    const bService = b[index][0].Date;
                    if (!isDesc) {
                        return aService < bService ? -1 : 1;
                    } else {
                        return bService < aService ? -1 : 1;
                    }
                } else if (index === 'State') {
                   
                    const aService = a[index][0].Name;
                    const bService = b[index][0].Name;
                    if (!isDesc) {
                        return aService < bService ? -1 : 1;
                    } else {
                        return bService < aService ? -1 : 1;
                    }
                } else if (index === 'PartyService') {
                 
                    const aService = a[index][0].Name;
                    const bService = b[index][0].Name;
                    if (!isDesc) {
                        return aService < bService ? -1 : 1;
                    } else {
                        return bService < aService ? -1 : 1;
                    }
                } else {
                    if (!isDesc) {
                        return a[index] < b[index] ? -1 : 1;
                    } else {
                        return b[index] < a[index] ? -1 : 1;
                    }
                }
            });
            return items;
        },
        PERFORM_SEARCH: function () {
            let query = this.$router.query || {};
            let index = 0;

            if (this.search) {
                query.s = this.search;
            }

            this.filteredItems = this.items.slice()
                .filter(i => (
                        (i.DisplayName.toLowerCase().indexOf(this.search.toLowerCase()) > -1)
                    || (i.PartyService.filter(e => e.Name.toLowerCase().indexOf(this.search.toLowerCase()) > -1).length > 0))
                    || (i.State.filter(e => e.Name.toLowerCase().indexOf(this.search.toLowerCase()) > -1).length > 0));

            if (this.SELECTED_STATES.length > 0) {
                if (this.filteredItems.length === 0) {
                    this.filteredItems = this.items.slice();
                }

                this.filteredItems = this.filteredItems.filter(i => i.State.filter(e => this.SELECTED_STATES.indexOf(e.Name) > -1).length > 0);
            }

            if (this.SELECTED_PARTIES.length > 0) {
                if (this.filteredItems.length === 0) {
                    this.filteredItems = this.items.slice();
                }

                this.filteredItems = this.filteredItems.filter(i => i.PartyService.filter(e => this.SELECTED_PARTIES.indexOf(e.Name) > -1).length > 0);
            }

            if (!this.search && this.SELECTED_PARTIES.length == 0 && this.SELECTED_STATES.length == 0) {
                this.filteredItems = this.items.slice();
            }
        },
        FILTER_STATE_OPTIONS: function (item, queryText) {
            const abbrev = item.Abbrev.toLowerCase();
            const name = item.Name.toLowerCase();
            const searchText = queryText.toLowerCase()
            return name.indexOf(searchText) > -1 || abbrev.indexOf(searchText) > -1;
        },
        exportCsv: function () {
            this.csvDownloading = true;
            const filename = 'Aboriginal and or Torres Strait Islander Parliamentarians';
            const comment = `Data current as of ${(new Date()).toLocaleDateString()}`;

            var getItems =  this.filteredItems.slice();
       
            const records = getItems.map(i => 
                ({ 
                    Phid: i.Phid,
                    DisplayName: i.DisplayName, 
                    Notes: i.Notes,
                    Party: i.PartyService.map(p => p.Name).join(', '),
                    State: i.State.map(s => s.Name.toUpperCase()).filter((value, index, self) => index === self.findIndex(v => v.Id === value.Id)).join(', '),
                    'Period of service': i.Service.map(s => s.Text).join('\n')
                }));


            this.$store.dispatch('GETCSV', { DATA: records, HEADERS: this.CSV_HEADERS, FILENAME: filename, COMMENT: comment, STRICTHEADERS: true })
                .catch(this.showError)
                .finally(() => this.csvDownloading = false);
        },
        addCulturalSensitivityCookie() {
            var secure = location.hostname !== 'localhost';
            this.$cookies.set('handbook_culturalSensitivityWarningSeen_factsandfigures', 1, this.$moment(new Date()).add(99, 'years').toDate(), null, null, secure, 'strict');
            this.$cookies.set('handbook_culturalSensitivityWarningSeen', 1, this.$moment(new Date()).add(99, 'years').toDate(), null, null, secure, 'strict');
            this.dialog = false;
            this.hidePhotos = false;
        },
         ParliamentOrdinal: function (PID) {
                var parliament = parseInt(PID);
                if (parliament <= 0) return parliament;

                switch (parliament % 100) {
                    case 11:
                    case 12:
                    case 13:
                        return `${parliament}th`;
                }

                switch (parliament % 10) {
                    case 1:
                        return `${parliament}st`;
                    case 2:
                        return `${parliament}nd`;
                    case 3:
                        return `${parliament}rd`;
                    default:
                        return `${parliament}th`;
                }
            },
            stringDate (value) {
            if (value && value != 'undefined' && value != 'Undefined' 
            && value != '1900-01-01' 
            && value != '1900-01-01T00:00:00Z' 
            && value != '1900-01-1' 
            && value != '0001-01-01'
            && value != '0001-01-01T00:00:00Z') {
                var dateDMY = moment(String(value));
                if (dateDMY.isValid()){
                    return dateDMY.format('DD/MM/YYYY');
                }
                else {
                    var dateFormat =  moment(String(value), 'YYYY-DD-MM');
                    if (dateFormat.isValid()){
                        return dateFormat.format('DD/MM/YYYY');
                    }
                    else {
                        return ''
                    }
                }
            } else {
                return 'present'
            }
        },
        onResize() {
            if (window.innerWidth < 769){
                this.isMobile = true;
            }
            else{
                this.isMobile = false;
            }
        },
        changeSort(column) {
            if (this.PAGINATION.sortBy === column) {
                this.PAGINATION.descending = !this.PAGINATION.descending
            } 
            else {
                this.PAGINATION.sortBy = column
                this.PAGINATION.descending = false
            }
        },
    },
    computed: {
            currentParties: function () {
                    let parties = [];
                    if (this.$store.getters.GET_PARLIAMENTS_ORDERED && this.$store.getters.GET_PARLIAMENTS.length > 0) {
                        let pid = this.$store.getters.GET_PARLIAMENTS_ORDERED[0].PID;
                        parties = this.$store.getters.GET_PARLIAMENTS_ORDERED.find(p => p.PID === pid).PartiesByParliament;
                    }
                    return parties;
            },
            stateSelectLabel: function () {
                    var label = 'Select a State Represented';
                    if (this.$vuetify.breakpoint.name === 'xs' || this.$vuetify.breakpoint.name === 'sm') {
                        label = 'State';
                    }
                    return label;
            },
            partySelectLabel: function () {
                var label = 'Select a Party';
                if (this.$vuetify.breakpoint.name === 'xs' || this.$vuetify.breakpoint.name === 'sm') {
                    label = 'Party';
                }
                return label;
            },
            debouncedOnChange () {
                return _debounce(this.PERFORM_SEARCH, 700);
            },
            csvDownloadIcon(){
                return this.csvDownloading ? 'cached' : 'text_snippet';
            },
            csvDownloadClass(){
                let csvClass = 'mr-1';
                if (this.csvDownloading){
                    csvClass = csvClass + ' loading'
                }
                return csvClass;
            },
            totalIndigenousCountText: function (){
                return this.selectedMpOrSenator.length == 2 ? "Indigenous <br/>Parliamentarians" 
                    : (this.selectedMpOrSenator[0] == "mp" ? "Indigenous <br/>Members" : "Indigenous <br/>Senators" )
            },
            indigenousAustraliansInCurrentParliamentText: function (){
                return this.selectedMpOrSenator.length == 2 ? "Indigenous Parliamentarians in<br/>current Parliament" 
                    : (this.selectedMpOrSenator[0] == "mp" ? "Indigenous <br/>Members in current<br/>Parliament"  : "Indigenous <br/>Senators in current<br/>Parliament"  )
            },
            uniqueParties() {
                return [...new Set(this.items.flatMap(i => i.PartyService).map(i => i.Name))];
            },
            byPartyData() {
                const parties = orderBy(this.uniqueParties, 
                [p => this.filteredItems.flatMap(i => this._.uniqBy(i.PartyService, 'Name')).filter(i => i.Name === p).length,
                p => p],
                ['desc', 'asc'],
                );

                return {
                    chart: {
                        type: 'bar'
                    },
                    title: {
                        text: 'Number of Aboriginal and/or Torres Strait Islander Parliamentarians by party'
                    },
                    xAxis: {
                        categories: parties,
                        tickInterval: 1
                    },
                    yAxis: {
                        title: {
                            text: 'Parliamentarians per party'
                        },
                        tickInterval: 1
                    },
                    legend: {
                        enabled: false
                    },
                    exporting: {
                        filename: 'Number of Aboriginal and/or Torres Strait Islander Parliamentarians by party'
                    },
                    series: [{
                        name: 'Aboriginal and/or Torres Strait Islander Parliamentarians',
                        data: orderBy(parties
                        .map(p => ({ 
                            y: this.filteredItems.flatMap(i => this._.uniqBy(i.PartyService, 'Name')).filter(i => i.Name === p).length,
                            color: this.items.flatMap(i => i.PartyService).find(i => i.Name === p).Colour })),
                        [i => i],
                        ['desc']
                        )
                    }] 
                }
            },
            byParliamentData() {
                const series = [ 'House of Representatives', 'Senate']
                    .map(h => ({
                    name: h,
                    data: []
                }));

                const categories = [];
                var data = this.$store.getters.GET_PARLIAMENTS.filter(p => p.PID >= 26);

                data.forEach(d => {
                    categories.push(d.PID);
                    const house = series[0];
                    const senate = series[1];

                    house.data.push({
                        title: 'Members',
                        color: this.$store.state.COLOUR_REPRESENTATIVES,
                        name: d.Name,
                        dateString: this.stringDate(d.DateOpening)  + ' - ' + this.stringDate(d.DateDissolution),
                        y: this.filteredItems.flatMap(i => [...new Set(i.Service.filter(s => s.Chamber == "House").flatMap(s => s.ParliamentList))]).filter(i => i === d.PID).length
                    });

                    senate.data.push({
                        title: 'Senators',
                        color: this.$store.state.COLOUR_SENATE,
                        name: d.Name,
                    dateString: this.stringDate(d.DateOpening)  + ' - ' + this.stringDate(d.DateDissolution),
                        y: this.filteredItems.flatMap(i => [...new Set(i.Service.filter(s => s.Chamber == "Senate").flatMap(s => s.ParliamentList))]).filter(i => i === d.PID).length
                    });
                });


                return {
                    chart: {
                        type: 'column'
                    },
                     legend: {
                        enabled: false
                    },
                    title: {
                        text: 'Number of Aboriginal and/or Torres Strait Islander Parliamentarians by Parliament'
                    },
                    xAxis: {
                        title: {
                            text: 'Parliaments'
                        },
                         categories: categories,
                        // categories: this.$store.getters.GET_PARLIAMENTS.filter(p => p.PID >= 27).map(p => p.PID),
                        tickInterval: 1
                    },
                    yAxis: {
                        title: {
                            text: 'Aboriginal and/or Torres Strait Islander Parliamentarians'
                        },
                        tickInterval: 1
                    },
                    exporting: {
                        filename: 'Number of Aboriginal and/or Torres Strait Islander Parliamentarians by Parliament'
                    },
                    tooltip: {
                        shared: true,
                        split: false,
                        followPointer: true,
                        borderWidth: 0,
                        backgroundColor: 'transparent',
                        shadow: false,
                        formatter: function () {
                           var points = this.points;
                            var pointsLength = points.length;
                            var tooltipMarkup = '<div style="display:inline-block; padding-left:10px;">' 
                            + '<span style="font-size:1.1em;font-weight:bold;">' + points[0].key + '</span><br />' 
                            + '<span>' + points[0].point.dateString + '</span>'
                            + '<br/>';
                            var index;
                            for (index = 0; index < pointsLength; index += 1) {
                                tooltipMarkup += '<span style="color:' + points[index].point.color + '">\u25CF</span> ' + points[index].series.name + ': <b>' 
                                    + '</b> '+ points[index].point.y + ' ' + points[index].point.title
                                    + '<br/>' ;
                            }
                            return '<div class="tooltip">' + tooltipMarkup +'</div></div>';
                        },    
                        useHTML: true,
                    },
                    series
                }
            },
            byStateData() {
                const states = orderBy(this.$store.getters.GET_STATES.map(i => i), 
                [p => this.filteredItems.flatMap(i => this._.uniqBy(i.State, 'Name')).filter(i => i.Name.toLowerCase() === p.Abbrev.toLowerCase()).length,
                p => p],
                ['desc', 'asc'],
                );

                const series = states
                .map((p, index) => ({
                    name: p.Name,
                    states: {
                        hover: {
                            enabled: false
                        }
                    },
                    data: [{  name: p.Name,
                     x: index,
                     y: this.filteredItems.flatMap(i => this._.uniqBy(i.State, 'Name')).filter(i => i.Name.toLowerCase() === p.Abbrev.toLowerCase()).length }]
                }));

                return {
                    chart: {
                        type: 'bar'
                    },
                    title: {
                        text: 'Number of Aboriginal and/or Torres Strait Islander Parliamentarians by state/territory'
                    },
                    xAxis: {
                        categories: series.map(i => i.name),
                        tickInterval: 1,
                        
                    },
                    yAxis: {
                        title: {
                            text: 'Parliamentarians per state/territory'
                        },
                        tickInterval: 1
                    },
                    exporting: {
                        filename: 'Number of Aboriginal and/or Torres Strait Islander Parliamentarians by state/territory'
                    },
                    series
                }
            },
            timelineData() {
                var that = this;
                let data = [];
                let categories = [];

                var min = new Date(1969,1,1).valueOf()
                var max = new Date().valueOf();

                this.filteredItems.forEach((p, pi) => {
                    p.CombinedService.forEach((d, i) => {
                        // add in item. if previous item is connected, just edit latest item
                        if (i === 0) {
                            categories.push(p.DisplayName);
                            data.push({
                                name: p.DisplayName,
                                PHID: p.Phid,
                                Party: d.Name,
                                x: new Date(d.Date).valueOf(),
                                x2: new Date(d.DateEnd).valueOf(),
                                dateString: d.Text,
                                y: pi,
                                color: d.Colour
                            });
                        }
                        else {
                            const previous = p.CombinedService[i - 1];
                            // if joined
                            if (new Date(previous.DateEnd).addDays(1) >= new Date(d.Date)
                            && previous.Name == d.Name) {
                                // join
                                data[data.length - 1].x2 = new Date(d.DateEnd).valueOf();
                            } else {
                                data.push({
                                    name: p.DisplayName,
                                    PHID: p.Phid,
                                    Party: d.Name,
                                    x: new Date(d.Date).valueOf(),
                                    x2: new Date(d.DateEnd).valueOf(),
                                    dateString: d.Text,
                                    y: pi,
                                    color: d.Colour
                                });
                            }
                        }
                    });
                });

                data = this._.orderBy(data, d => d.x)

                return {
                    chart: {
                        marginLeft: this.isMobile ? 0 : 400,
                        type: 'xrange',
                        height: (this.isMobile ? 400 : 500),
                        events: {
                            render: function() {
                                var axis = this.yAxis[0];
                                var ticks = axis.ticks;
                                var points = this.series[0].points;
                                var chart = this;
                                if (!this.isMobile){
                                    Object.keys(ticks).forEach(function(t,index) {
                                        var tick = ticks[index];
                                        if (tick){
                                            var label = tick.label.element;
                                            var point = points.find(p => p.name == tick.label.textStr);

                                            if (point){
                                                label.onclick = function() {
                                                    that.$router.push({ name: that.$store.state.ROUTE_PARLIAMENTARIAN, params: { PHID: point.PHID }});
                                                }

                                                label.onmouseover = function() {
                                                    that.hoveredPoint = point;
                                                    that.hoveringLabel = true;
                                                    chart.tooltip.refresh(point)
                                                } 
                                                
                                                label.onmouseout = function() {
                                                    chart.tooltip.hide();
                                                    that.hoveringLabel = false;
                                                }
                                            }
                                        }
                                    });
                                }
                            }
                        }
                    },
                    plotOptions: {
                        series: {
                            cursor: 'pointer',
                            point: {
                                events: {
                                    click: function () {
                                        that.$router.push({ name: that.$store.state.ROUTE_PARLIAMENTARIAN, params: { PHID: this.PHID }});
                                    },
                                    mouseOver: function() {
                                        that.hoveredPoint = this;
                                        that.hoveringLabel = false;
                                    },
                                    mouseOut: function() {
                                        that.hoveredPoint = null;
                                        that.hoveringLabel = false;
                                    }
                                }
                            }
                        }
                    },
                    tooltip: {
                        borderWidth: 0,
                        backgroundColor: 'transparent',
                        shadow: false,
                        useHTML: true,
                        enabled: this.isMobile ? false : true,
                        formatter: function () {
                            var todaysDate = new Date();
                            var dateIsToday = new Date(this.x2).setHours(0,0,0,0) == todaysDate.setHours(0,0,0,0);
                            var showEndDate = dateIsToday ? 'present' : new Date(this.x2).toLocaleDateString('en-AU');

                            var tooltipMarkup = '<div class="tooltip" style="width:300px;min-height: 100px;">'
                            + '<div style="display:inline-block;"><img src="https://www.aph.gov.au/api/parliamentarian/' 
                            + this.point.PHID  
                            + '/image" style="width: 80px;border-radius: 5px;" /></div><div style="vertical-align: top;display:inline-block; width:200px; padding-left:10px;">' 
                     
                            + (!that.hoveringLabel ? 
                                ('<p style="font-size:1.1em;font-weight:bold;white-space: normal;">' + this.point.name + '</p>' 
                                + '<p style="white-space: normal; margin-bottom:0.2rem;">' + this.point.Party + '</p>'
                                + '<p style="white-space: normal; margin-bottom:0.2rem;">' + new Date(this.x).toLocaleDateString('en-AU') + ' - ' + showEndDate + '</p>')
                                : '<p style="font-size:1.1em;font-weight:bold;margin-top: 35px;white-space: normal;">' + this.point.name + '</p>' )
                            + '</div></div>';
                       
                            return tooltipMarkup ;
                        },    
                        positioner: function() {
                            var x = that.hoveredPoint.shapeArgs.x;
                            var y = that.hoveredPoint.shapeArgs.y;
                         
                            return {
                                x: that.hoveringLabel ? 380 : x + 80,
                                y: y + 40
                            }
                        },
                    },
                    legend: {
                        enabled: false
                    },

                    title: {
                        text: "Aboriginal and/or Torres Strait Islander Parliamentarians"
                    },
                    exporting: {
                        filename: 'Aboriginal and/or Torres Strait Islander Parliamentarians',
                        sourceWidth: 2000
                    },
                    xAxis: {
                        type: 'datetime',
                        min: min,
                        max: max
                    },

                    yAxis: {
                        title: {
                            text: ''
                        },
                        type: 'category',
                        labels: {
                            step: 1,
                            enabled: this.isMobile ? false : true,
                        },
                        categories,
                        reversed: true
                    },
                    series: [{
                        name: 'Parliamentary service',
                        pointWidth: this.isMobile ? 7 : 10,
                        data,
                    }]                    
                }
        },
           
    }, 
    beforeMount() {
        var cookie = this.$cookies.get('handbook_culturalSensitivityWarningSeen_factsandfigures');

        if (parseInt(cookie) === 1) {
            this.dialog = false;
            this.hidePhotos = false;
        }
        else {
            this.dialog = true;
        }
    },  
    mounted(){
        this.onResize();
    },
    watch: {
        selectedMpOrSenator: function () {
            this.initialiseItems();
        }
    },
    data() {
        return {
        title: 'Aboriginal and/or Torres Strait Islander Parliamentarians',
        dialog: true,
        isMobile: false,
        chartType: 'timeline',
        hidePhotos: true,
        totalIndigenousCount: 0,
        indigenousAustraliansInCurrentParliament: 0,
        StatesToExclude: [],
        CSV_HEADERS: [
            { label: 'PHID', value: 'Phid' }, 
            { label: 'Name', value: 'DisplayName' },
            { label: 'Notes', value: 'Notes' },
            { label: 'Party', value: 'Party' }, 
            { label: 'State', value: 'State' },
            { label: 'Service', value: 'Period of service' }
        ],
        headers: [
            {
                text: '',
                value: 'DisplayName',
                width: "140px",
                sortable: false
            },
            {
                text: 'Parliamentarian',
                value: 'DisplayName'
            },
            {
                text: 'Party',
                value: 'PartyService'
            },
            {
                text: 'State',
                value: 'State'
            },
            {
                text: 'Period of service',
                value: 'Service'
            }
        ],
        items: [],
        filteredItems: [],
        search: '',
        partySearchInput: '',
        stateSearchInput: '',
        SELECTED_STATES: [],
        SELECTED_PARTIES: [],
        PARTIES: this.$store.getters.GET_PARTIES,
        isOpen: false,
        hoveredPoint: null,
        hoveringLabel: false,
        loading: true,
        csvDownloading: false,
        selectedMpOrSenator: ['senator', 'mp'],
        memberOrSenator: 'member',
        PAGINATION: {
            rowsPerPage: -1,
            sortBy: '',
            descending: true
        },
        rowsPerPageItems: [ 10, 25, {
            "text": "$vuetify.dataIterator.rowsPerPageAll",
            "value": -1
            }]
        }
    }
}
</script>
<style scoped>
    a {
        text-decoration: none;
    }
    .handbook_toggleButton {
        flex-wrap: wrap;
    }
</style>
<style lang="stylus" scoped>

    #timeline >>> div {
        overflow: visible !important;
    }

    #timeline >>> .highcharts-container {
        overflow: visible !important;
    }

    #timeline >>> .highcharts-container svg {
        overflow: visible !important;
    }

    #timeline >>> .highcharts-tooltip span {
        background-color: transparent;
    }

    #timeline >>> .highcharts-yaxis-labels text {
        cursor: pointer !important;
    }

   #byParliament >>> .highcharts-tooltip span {
        left: 0px;
        top: 0px;
       border:none !important;
       background-color: transparent !important;
    }
     .highcharts-container {
    overflow: visible !important;
  }

  .highcharts-container svg {
    overflow: visible !important;
  }
</style>
